import { useEffect, useState } from 'react';
import type { AbstractResponsiveType } from '@whitesharx/starfall-frontend-core';

import { isClient } from '~/src/constants/env';

const baseViews = { isMobile: false, isTablet: false, isDesktop: false };

type BreakPoints = Record<'desktop' | 'tablet' | 'mobile', number>;

const equals = (oldState: AbstractResponsiveType, newState: AbstractResponsiveType) => {
  return (
    oldState.isDesktop === newState.isDesktop &&
    oldState.isTablet === newState.isTablet &&
    oldState.isMobile === newState.isMobile
  );
};

const calculateView = (width: number, breakPoints: BreakPoints) => {
  const views = { ...baseViews };

  if (width >= breakPoints.desktop) {
    views.isDesktop = true;
  }
  if (width >= breakPoints.tablet && width < breakPoints.desktop) {
    views.isTablet = true;
  }
  if (width < breakPoints.tablet) {
    views.isMobile = true;
  }

  return views;
};

const useResponsiveFlags = (breakPoints: BreakPoints): AbstractResponsiveType => {
  const [state, setState] = useState<AbstractResponsiveType>(
    isClient ? calculateView(window.innerWidth, breakPoints) : baseViews
  );

  const handleResize = () => {
    const newState = calculateView(window.innerWidth, breakPoints);
    if (!equals(state, newState)) {
      setState(newState);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return state;
};

export default useResponsiveFlags;
